msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2025-08-14 12:05+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: es\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: Poedit 3.6\n"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:11
msgid "safeSend.tabs.header.dbName"
msgstr "Nombre"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:16
msgid "safeSend.tabs.header.emails"
msgstr "Direcciones de email excluidas"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:23
msgid "safeSend.tabs.header.actions"
msgstr "Acciones sospechosas"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:30
msgid "safeSend.tabs.header.status"
msgstr "Estado"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/NewFeatureBanner/index.tsx:8
msgid "features.newFeatureBanner.safesend"
msgstr "<bold>⭐️ Novedad:</bold> SafeSend, el filtro para direcciones de email peligrosas"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:73
msgid "features.footer.followEmailTrainingLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/formations-email-delivrabilite-deduplication-et-reactivation-des-inactifs/"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:85
msgid "features.footer.learnMoreLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/audits-conseils-gestion-emailing/"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:36
msgid "dashboards.menuCards.deliverability.content"
msgstr "Vista global de tu entregabilidad en todas las bases de datos"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:38
msgid "dashboards.menuCards.deliverability.title"
msgstr "Reporte de entregabilidad"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:43
msgid "dashboards.menuCards.campaign.content"
msgstr "Analiza el rendimiento de campañas y segmentos en cada base de datos"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:45
msgid "dashboards.menuCards.campaign.title"
msgstr "Estadísticas de campaña"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:59
msgid "dashboards.title"
msgstr "¡Bienvenido a Mindbaz Dashboards!"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:60
msgid "dashboards.description"
msgstr "Rastrea la entregabilidad y el rendimiento de las campañas en tus bases de datos de Mindbaz. Con nuestro panel \"Reporte de entregabilidad\", puedes monitorear la entregabilidad y la reputación de tus dominios y direcciones IP en los ISP. Analiza el rendimiento de las campañas en conjunto o por segmento con nuestro panel \"Estadísticas de Campaña\"."

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:75
msgid "dashboards.customDashboards"
msgstr "Paneles personalizados"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:105
msgid "dashboards.needCustomDashboard"
msgstr "¿Necesitas un panel personalizado?"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:99
msgid "snapshot.gridPerformances.header.sentRate"
msgstr "Tasa de envío"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:106
msgid "snapshot.gridPerformances.header.deliveredEmails"
msgstr "Emails entregados"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:113
msgid "snapshot.gridPerformances.header.hardBounce"
msgstr "Rebote duro"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:121
msgid "snapshot.gridPerformances.header.openers"
msgstr "Aperturas"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:128
msgid "snapshot.gridPerformances.header.clickers"
msgstr "Clics"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:135
msgid "snapshot.gridPerformances.header.unsubscribes"
msgstr "Bajas"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:145
msgid "table.labelRowsPerPage"
msgstr "Resultados por página:"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:147
msgid "table.labelDisplayedRowsSeparator"
msgstr "de"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:150
msgid "table.labelNoRows"
msgstr "Lo sentimos, ningún resultado coincide con tu búsqueda"

#. js-lingui-explicit-id
#: src/pages/DailyReport/TabInformations/index.tsx:46
msgid "snapshot.databases"
msgstr "Base de datos"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:130
msgid "safesend.dailyStats.excludedEmails"
msgstr "Direcciones de email excluidas"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:134
msgid "safesend.dailyStats.suspiciousActions"
msgstr "Acciones sospechosas"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:156
#: src/pages/SafeSend/index.tsx:174
msgid "safesend.databaseStats.fromDate"
msgstr "Activado desde {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:165
msgid "safesend.databaseStats.untilDate"
msgstr "Activado hasta {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:186
msgid "safesend.databaseStats.dateRange"
msgstr "Desde {startDate} hasta {endDate}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:194
msgid "safesend.cards.emails.title"
msgstr "Direcciones de email excluidas"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:195
msgid "safesend.cards.emails.description"
msgstr "{data} direcciones de email han sido excluidas de tus envíos."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:204
msgid "safesend.cards.actions.title"
msgstr "Acciones sospechosas"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:205
msgid "safesend.cards.actions.description"
msgstr "Las acciones de {data} direcciones de email sospechosas han sido limitadas en tus estadísticas."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:235
msgid "table.search"
msgstr "Buscar"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:236
msgid "table.elementsTabCount"
msgstr "elementos en mi página"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:245
msgid "safesend.title"
msgstr "SafeSend"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:246
msgid "safesend.description"
msgstr "Rastrea el número de direcciones de email excluidas de tus envíos y cuyas acciones están limitadas en tus estadísticas gracias a SafeSend. Para obtener más información sobre SafeSend, "

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:248
msgid "safesend.descriptionLink"
msgstr "https://serviceclient.mindbaz.com/es/faq/safesend-le-filtre-%C3%A0-emails-dangereux-par-mindbaz"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:257
msgid "safesend.panel.title"
msgstr "Selección de período"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:258
msgid "safesend.panel.period"
msgstr "Período"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:341
msgid "safesend.popup.title"
msgstr "Selección de período"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:346
msgid "safesend.popup.description"
msgstr "Para modificar la oferta SafeSend, por favor contacta a un administrador: {adminList}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:107
msgid "snapshot.tabs.general.title"
msgstr "General"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:120
msgid "snapshot.tabs.performance.title"
msgstr "Rendimiento por base de datos"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:152
msgid "snapshot.title"
msgstr "¡Bienvenido a tu instantánea de entregabilidad!"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:153
msgid "snapshot.description"
msgstr "Consulta tus estadísticas de email para <strong>{values}</strong>. En la <strong>pestaña General</strong>, encontrarás las alertas de entregabilidad que estaban activas en esta fecha y el rendimiento de tus bases de datos. Si quieres una vista detallada por base de datos, usa la <strong>pestaña Rendimiento por Base de Datos</strong>."

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:158
msgid "snapshot.displayStatistics"
msgstr "Mostrar estadísticas el"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:172
msgid "snapshot.switch_apple_mpp.label"
msgstr "Incluir"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:176
msgid "snapshot.switch_apple_mpp.link"
msgstr "https://serviceclient.mindbaz.com/es/faq/apple-mail-privacy-protection-mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:178
msgid "snapshot.switch_apple_mpp.linkText"
msgstr "Apple MPP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:180
msgid "snapshot.switch_apple_mpp.endLabel"
msgstr "aperturas"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:5
msgid "features.cards.safesend.title"
msgstr "Filtrar automáticamente emails peligrosos"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:6
msgid "features.cards.safesend.description"
msgstr "SafeSend es el filtro de Mindbaz que elimina automáticamente las direcciones de email peligrosas de tus envíos."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:7
msgid "features.cards.safesend.bafflingProblem"
msgstr "Tus campañas de email están afectadas por bots, quejas de spam, trampas de spam y emails desechables, que reducen tu tasa de entregabilidad y tu reputación con los ISP."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:8
msgid "features.cards.safesend.goal"
msgstr "Envía tus campañas solo a las direcciones correctas y optimiza tu entregabilidad sin esfuerzo."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:9
msgid "features.cards.safesend.activateFeature"
msgstr "Activar SafeSend"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:12
msgid "features.cards.dashboards.title"
msgstr "Visualiza el rendimiento de todas tus bases de datos con una vista global"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:13
msgid "features.cards.dashboards.description"
msgstr "Con Dashboards, ya no necesitas salir de tu enrutador de email para analizar todas tus campañas."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:14
msgid "features.cards.dashboards.bafflingProblem"
msgstr "Para enviar campañas de email masivas, la mayoría de nuestros clientes utilizan diferentes bases de datos. Cuando la misma campaña de email se envía a varias bases de datos, ¿cómo estimas el rendimiento general de la campaña en los Proveedores de Servicios de Correo?"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:15
msgid "features.cards.dashboards.goal"
msgstr "Usa una herramienta de visualización de datos multi-base."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:16
msgid "features.cards.dashboards.activateFeature"
msgstr "Prueba gratuita de 30 días"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:19
msgid "features.cards.snapshot.title"
msgstr "Obtén una instantánea diaria de tu entregabilidad"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:20
msgid "features.cards.snapshot.description"
msgstr "Snapshot te permite anticipar problemas de entregabilidad para resolverlos rápidamente."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:21
msgid "features.cards.snapshot.bafflingProblem"
msgstr "Las agencias que envían campañas de email masivas pueden estar sujetas a riesgos de entregabilidad y cambios en las mejores prácticas. Si estás verificando cada campaña individualmente para tratar de entender la razón de una caída en la entregabilidad, es una pérdida de tiempo."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:22
msgid "features.cards.snapshot.goal"
msgstr "Ahorra tiempo analizando tu entregabilidad en los Proveedores de Servicios de Correo aprovechando una instantánea diaria de tu entregabilidad."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:23
msgid "features.cards.snapshot.activateFeature"
msgstr "Prueba gratuita de 30 días"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:28
msgid "safesend.panel.thirtyLastDays"
msgstr "Últimos 30 días"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:29
msgid "safesend.panel.currentMonth"
msgstr "Mes actual"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:30
msgid "safesend.panel.lastMonth"
msgstr "Mes pasado"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:31
msgid "safesend.panel.threeLastMonths"
msgstr "Últimos 3 meses"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:32
msgid "safesend.panel.sixLastMonths"
msgstr "Últimos 6 meses"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:321
msgid "snapshot.general.preblockSummary"
msgstr "Prebloqueo de Mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:322
#: src/pages/DailyReport/useCards.tsx:340
msgid "snapshot.general.preblock.level"
msgstr "Niv. "

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:360
msgid "snapshot.general.blacklistSummary"
msgstr "Lista negra"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:379
msgid "snapshot.general.undelegatedSummary"
msgstr "Dominio no delegado"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:447
msgid "{nbPreblock, plural, one {# Mindbaz Preblock} other {# Mindbaz Preblocks}}"
msgstr "{nbPreblock, plural, one {# Prebloqueo Mindbaz} other {# Prebloqueos Mindbaz}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:457
msgid "snapshot.general.noPreblock"
msgstr "Sin prebloqueo actual de Mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:465
msgid "{nbBlacklist, plural, one {# Blacklist} other {# Blacklists}}"
msgstr "{nbBlacklist, plural, one {# Lista negra} other {# Listas negras}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:471
msgid "snapshot.general.noBlacklist"
msgstr "Sin lista negra"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:479
msgid "{nbUndelegated, plural, one {# Undelegated domain} other {# Undelegated domains}}"
msgstr "{nbUndelegated, plural, one {# Dominio no delegado} other {# Dominios no delegados}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:489
msgid "snapshot.general.noUndelegated"
msgstr "Todos tus dominios están delegados"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:497
msgid "snapshot.general.performance"
msgstr "Rendimiento por base de datos"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:544
msgid "snapshot.performance.email"
msgstr "Emails enviados por ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:566
msgid "snapshot.performance.deliverability"
msgstr "Entregabilidad por ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:585
msgid "{nbDeliverabilityAlert, plural, one {# deliverability alert} other {# deliverability alerts}}"
msgstr "{nbDeliverabilityAlert, plural, one {# alerta de entregabilidad} other {# alertas de entregabilidad}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:595
msgid "snapshot.performance.noDeliverabilityAlert"
msgstr "Sin alerta de entregabilidad actual"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:603
msgid "snapshot.performance.performance"
msgstr "Rendimiento por ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:620
msgid "snapshot.performance.spamVol"
msgstr "Quejas de spam (vol.)"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:623
#: src/pages/DailyReport/useCards.tsx:651
msgid "snapshot.performance.noResult"
msgstr "Sin quejas de spam el {{date}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:648
msgid "snapshot.performance.spamPercent"
msgstr "Quejas de spam (%)"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:154
msgid "features.goal"
msgstr "🎯 Tu objetivo"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:148
msgid "features.bafflingProblem"
msgstr "🤯 El rompecabezas"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:249
msgid "safesend.descriptionClickHere"
msgstr "haz clic aquí."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:325
msgid "safesend.databaseDetails"
msgstr "Detalles por base de datos"

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:159
msgid "features.description"
msgstr "Descubre las funcionalidades de Rubixo que se basan en el análisis de 16 mil millones de emails enrutados por Mindbaz cada año."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:88
msgid "feature.footer.learnMore"
msgstr "Obtén más información sobre las auditorías de email de Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:131
msgid "features.learnMore"
msgstr "Obtener más información"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:45
msgid "gone_page.link"
msgstr "Obtener más información sobre Dashboards"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:31
msgid "page_not_found.button"
msgstr "Iniciar sesión en Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:112
msgid "features.manageOffer"
msgstr "Gestionar mi suscripción"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:337
msgid "safesend.updateOffer"
msgstr "Modificar mi oferta SafeSend"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:351
msgid "safesend.popup.confirm"
msgstr "Modificar mi oferta SafeSend"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:34
msgid "feature.footer.featureInProgress"
msgstr "Más funcionalidades están en camino."

#. js-lingui-explicit-id
#: src/pages/Common/AccessDenied.tsx:38
msgid "oops"
msgstr "¡Ups! No tienes acceso a esta plataforma."

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:31
msgid "gone_page.description1"
msgstr "Los reportes Snapshot son accesibles <strong>7 días</strong> después de haber sido publicados."

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:151
msgid "features.title"
msgstr "Resuelve el rompecabezas de la entregabilidad de email con Rubixo"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:40
msgid "feature.footer.follow"
msgstr "¡Mantente al tanto para no perderte nada!"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:76
msgid "feature.footer.followEmailTraining"
msgstr "Toma un curso de formación en email con Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:20
msgid "page_not_found.title"
msgstr "Esta página no existe"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:25
msgid "gone_page.title"
msgstr "Este reporte Snapshot ya no está disponible"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:37
msgid "gone_page.description2"
msgstr "Para tener una vista completa de tus envíos, te invitamos a descubrir Dashboards."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:66
msgid "feature.footer.optimizeEmail"
msgstr "¿Quieres optimizar tu marketing por email?"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:24
msgid "page_not_found.description"
msgstr "No encontramos la página que estabas buscando"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:105
msgid "features.freeAccess"
msgstr "Actualmente tienes acceso gratuito"
